<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="create-card-edition-dialog"
      :open.sync="openDialog"
      :form-ref.sync="cardEditionFormRef"
      :hideActionBar="step < 3"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Créer une édition de cartes</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container class="pa-0">
          <card-edition-form
            :form.sync="cardEditionForm"
            :rules="rules"
            :step.sync="step"
            :restrictions="restrictionTypesChoice"
            :stepOneError="stepOneError"
            :stepTwoError="stepTwoError"
          ></card-edition-form>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>
        <span v-if="editMode">Modifier</span>
        <span v-else>Créer</span>
      </template>
      <template v-slot:[`dialog.actions.extra`] v-if="editMode">
        <v-btn color="error">Supprimer</v-btn>
      </template>
    </base-dialog>
    <delete-dialog :open.sync="openDeleteDialog">
      <template #title> Suppression de l'édition de carte </template>
      Vous êtes sur le point de supprimer cette édition de carte. Voulez-vous
      continuer ?
    </delete-dialog>
    <loading-dialog v-if="loadingDelete">
      <template #loading-text>Suppression</template>
    </loading-dialog>
  </div>
</template>
<script>
import { defineComponent, computed, toRefs, ref } from "@vue/composition-api";
import BaseDialog from "@/components/General/BaseDialog.vue";
import DeleteDialog from "@/components/General/DeleteDialog.vue";
import LoadingDialog from "@/components/General/LoadingDialog.vue";
import { useCardEdition } from "@/composables/cards-edition";
import CardEditionForm from "./CardEditionForm.vue";

export default defineComponent({
  components: {
    BaseDialog,
    DeleteDialog,
    LoadingDialog,
    CardEditionForm,
  },
  props: {
    open: Boolean,
    editMode: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const {
      editionData,
      createCardEdition,
      listCardEditions,
    } = useCardEdition();

    /* Variables */
    const openDeleteDialog = ref(false);
    const loadingDelete = ref(false);
    const step = ref(1);

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      if (editionData.cardEditionForm.cardModels) {
        editionData.cardEditionForm.cardModels.forEach((model) => {
          // Merge en secondes de l'unité et la valeur de de la durée de validité du modèle
          model.duration =
            parseInt(model.durationInput) * parseInt(model.durationUnit);
        });
      }

      await createCardEdition(editionData.cardEditionForm);
      openDialog.value = editionData.createCardEditionDialog;
      listCardEditions();
    };

    return {
      openDialog,
      ...toRefs(editionData),
      openDeleteDialog,
      loadingDelete,
      saveItem,
      step,
    };
  },
});
</script>
